/* eslint-disable no-underscore-dangle,no-useless-constructor,no-console,
graphql/template-strings */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// graphQL
import gql from 'graphql-tag';
// our components
import { Mutation, Query } from 'components/common/Query';
import RouterContext from 'helpers/routerContext';
import { sharedAdFields } from 'components/Ad/Details';
import { adopt } from 'react-adopt';
import { adStatus } from 'config';
import { bulkUpdate } from 'helpers/updateMutationsHelper';
import {
  PUBLISH_ADS_MUTATION,
  UNPUBLISH_ADS_MUTATION,
} from 'components/ReviewRules/Details';
import FlaggedAdDetails from './Details';

/**
 * Query to get IP flags
 */
export const FLAGGED_AD_IP = gql`
  query FlaggedAd($id: Int!) {
    flaggedAd(id: $id) {
      ${sharedAdFields}
      flagsIps {
        ip
        totalFlags
      }
    }
  }
`;

class FlaggedAdDetailsContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.Compose = adopt({
      queryBaseAd: this.baseAd,
      mutateAdPublishBaseAd: this.adPublishBaseAd,
      mutateAdUnPublishBaseAd: this.adUnPublishBaseAd,
    });
  }

  /**
   * @description
   * User's query callback to compose with mutations.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  baseAd = ({ render }) => {
    const { id } = this.props;
    return (
      <Query
        query={FLAGGED_AD_IP}
        variables={{ id }}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data }) => render({ data })}
      </Query>
    );
  };

  /**
   * @description
   * Mutation publish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adPublishBaseAd = ({ render }) => (
    <Mutation
      mutation={PUBLISH_ADS_MUTATION}
      update={(cache, { data: { publishAd } }) => {
        const data = {
          status: adStatus.PUBLISHED_BY_MODERATOR,
          __typename: 'AdminFlagAdType',
        };

        bulkUpdate(
          cache,
          'AdminFlagAdType',
          'Publish',
          'status',
          data,
          publishAd.successIds,
        );
      }}
    >
      {(handleAdPublishBaseAd, { loading }) =>
        render({ handleAdPublishBaseAd, loadingAdPublishBaseAd: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation unpublish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adUnPublishBaseAd = ({ render }) => (
    <Mutation
      mutation={UNPUBLISH_ADS_MUTATION}
      update={(cache, { data: { unPublishAd } }) => {
        const data = {
          status: adStatus.UNPUBLISHED_BY_MODERATOR,
          __typename: 'AdminFlagAdType',
        };

        bulkUpdate(
          cache,
          'AdminFlagAdType',
          'Unpublish',
          'status',
          data,
          unPublishAd.successIds,
        );
      }}
    >
      {(handleAdUnPublishBaseAd, { loading }) =>
        render({ handleAdUnPublishBaseAd, loadingAdUnPublishBaseAd: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Render FlaggedAdIps component.
   *
   * @returns {undefined} - No returns.
   */
  render() {
    return (
      <this.Compose>
        {({
          mutateAdPublishBaseAd: {
            handleAdPublishBaseAd,
            loadingAdPublishBaseAd,
          },
          mutateAdUnPublishBaseAd: {
            handleAdUnPublishBaseAd,
            loadingAdUnPublishBaseAd,
          },
          queryBaseAd: { data },
        }) => (
          <FlaggedAdDetails
            data={data && Object.keys(data).length > 0 ? data.flaggedAd : {}}
            adActionLoadingBaseAd={
              loadingAdPublishBaseAd || loadingAdUnPublishBaseAd
            }
            adPublishBaseAd={items => {
              handleAdPublishBaseAd({ variables: { ids: items } });
            }}
            adUnPublishBaseAd={items => {
              handleAdUnPublishBaseAd({ variables: { ids: items } });
            }}
          />
        )}
      </this.Compose>
    );
  }
}

/**
 * FlaggedAdIpsContainer PropTypes
 * @param id - prop to know id of the base Ad
 */

FlaggedAdDetailsContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default FlaggedAdDetailsContainer;
